import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { showErrorToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { savedSearchWebhooksQueryKeys } from "../key-factory/factory";

export const useDeleteSavedSearchWebhookMutation = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    return useMutation({
        mutationKey: savedSearchWebhooksQueryKeys.remove(),
        retry: 2,
        retryDelay: 200,
        mutationFn(webhookId: string) {
            return salesApiService.management.deleteSavedSearchWebhook(webhookId);
        },
        onSuccess() {
            queryClient.invalidateQueries({
                queryKey: savedSearchWebhooksQueryKeys.list(),
                refetchType: "inactive",
            });
        },
        onError() {
            dispatch(
                showErrorToast(
                    getToastItemComponent({
                        text: translate("si.management.saved-search-webhooks.delete-failed"),
                    }),
                ),
            );
        },
    });
};
